<template>
  <div class="fill-height">
    <template v-if="isLoading">
      <v-container class="fill-height">
        <v-row
          align="center"
          justify="center"
        >
          <v-progress-circular
            :size="80"
            color="accent"
            :width="8"
            indeterminate
          ></v-progress-circular>
        </v-row>
      </v-container>
    </template>
    <template v-else>
      <documents-toolbar
        @onRefresh="loadData"
      />
      <v-expansion-panels
        accordion
        multiple
        v-model="panel"
        style="padding-top: 49px;" class="documents">
        <v-expansion-panel v-for="(documents, storeId) in filteredRecords" :key="storeId" dense>
          <v-expansion-panel-header v-if="documents.length">
            {{_getStoreName(storeId)}}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col
              v-for="(document, i) in documents"
              :key="i"
              :class="{'pt-0' : i === 0}"
              cols="12">
              <v-card
                tile
                :loading="document.loading"
              >
                <v-card-text class="pa-2">
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div class="subtitle-2 grey--text text--darken-2">
                      <v-icon color="success" small v-if="document.process === 3">mdi-truck-check
                      </v-icon>
                      {{documentTitle(document.name)}} {{document.doc_id}}
                      <v-icon color="accent" small v-if="document.products">mdi-laptop</v-icon>
                    </div>
                    <div class="caption grey--text">{{document.created_on}}</div>
                  </div>
                  <div class="caption grey--text text--darken-1">{{document.kontragenti_name}}</div>
                  <div class="d-flex flex-no-wrap justify-start pt-2">
                    <v-icon left :color="document.address ? 'accent' : 'grey'">{{document.address ? 'mdi-map-marker' :
                      'mdi-map-marker-off'}}
                    </v-icon>
                    <div class="caption"
                         :class="{'grey--text text--darken-1' : !document.address, 'accent--text' : document.address}">
                      {{document.address || 'Адрес не указан. Уточните у менеджера.'}}
                    </div>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    icon
                    color="primary"
                    @click="setProcess(document,document.process === 2 ? 3 : 2)"
                  >
                    <v-icon>{{document.process === 2 ? 'mdi-download' : 'mdi-cancel'}}</v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="document.process === 2"
                    icon
                    color="primary"
                    @click="showShipConfirmationModal(document)"
                  >
                    <v-icon>mdi-upload</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-menu
                    v-if="document.managers && document.managers.length"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    offset-x
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="primary"
                        v-on="on"
                      >
                        <v-icon>mdi-account-tie</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(manager, index) in document.managers"
                        :key="index"
                      >
                        <v-list-item-content>
                          <v-list-item-title>{{ manager.name }}</v-list-item-title>
                          <v-list-item-subtitle><a :href="`tel:${manager.phone}`">{{ manager.phone }}</a>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-btn
                    icon
                    color="primary"
                    @click="openDocument(document)"
                  >
                    <v-icon>mdi-file-eye</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    color="primary"
                    @click="openComment(document)"
                  >
                    <v-icon>mdi-comment</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    color="primary"
                    @click="openPayment(document)"
                  >
                    <v-icon>mdi-cash-100</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <document
        ref="document"
      />
      <comment
        ref="comment"
      />
      <payment
        ref="payment"
      />
      <ship-confirmation-modal
        ref="shipConfirmationModal"
        @setProcess="setProcess"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapMultiRowFields, mapFields } from 'vuex-map-fields'
import documentsToolbar from './documentsToolbar'
import MinskApi from '../api'
import DocumentApi from 'app/document/api'
import { mapValues, remove, toLower } from 'lodash'
import document from 'app/document/components/document'
import comment from 'app/document/components/comment'
import payment from 'app/document/components/payment'
import shipConfirmationModal from './shipConfirmationModal'

export default {
  name: 'minskDocuments',
  components: {
    documentsToolbar,
    document,
    comment,
    payment,
    shipConfirmationModal
  },
  data () {
    return {
      isLoading: false,
      records: {},
      currencies: [],
      panel: []
    }
  },
  computed: {
    ...mapGetters('minsk', {
      _getStoreName: 'getStoreName'
    }),
    ...mapMultiRowFields('minsk', {
      _stores: 'stores'
    }),
    ...mapFields('minsk', {
      _searchTerm: 'searchTerm',
      _showLoadedOnly: 'showLoadedOnly'
    }),
    ...mapFields('tradle', {
      _messageBar: 'messageBar',
      _messageText: 'messageText',
      _messageType: 'messageType'
    }),
    filteredRecords () {
      let selectedStores = this._stores.filter(record => record.selected).map(record => record.id)
      let filteredByStore = Object.keys(this.records)
        .filter(key => selectedStores.includes(key))
        .reduce((obj, key) => {
          obj[key] = this.records[key]
          return obj
        }, {})
      if (this._searchTerm) {
        filteredByStore = mapValues(filteredByStore, (documents) => {
          return documents.filter((record) => toLower(record.doc_id).includes(toLower(this._searchTerm)) || toLower(record.kontragenti_name).includes(toLower(this._searchTerm)))
        })
      }
      if (this._showLoadedOnly) {
        filteredByStore = mapValues(filteredByStore, (documents) => {
          return documents.filter((record) => record.process === 3)
        })
      }
      return filteredByStore
    }
  },
  methods: {
    async loadData () {
      this.isLoading = true
      let response = await MinskApi.getDocuments()
      this.records = response.data
      let i = Object.keys(this.records).length
      for (let k = 0; k < i; k++) {
        this.panel.push(k)
      }
      this.currencies = response.currencies
      let stores = Object.keys(this.records)
      stores.forEach(storeId => {
        this._stores.find(record => record.id === storeId).active = true
      })
      this.isLoading = false
    },
    openDocument (document) {
      this.$refs.document.open(document.doc_id, document.kontragenti_name)
    },
    openComment (document) {
      this.$refs.comment.open(document.name, document.doc_id, document.kontragenti_name)
    },
    openPayment (document) {
      this.$refs.payment.open(document.name, document.doc_id, document.kontragenti_name, this.currencies)
    },
    documentTitle (documentName) {
      switch (documentName) {
        case 'rashodnayanakladnaya':
          return 'РН'
        case 'rashodnayanakladnaya_zakaz':
          return 'РНЗ'
        default:
          return ''
      }
    },
    async setProcess (document, process) {
      document.loading = true
      let response = await DocumentApi.setProcess({
        doc_id: document.doc_id,
        skladi_id: document.skladi_id,
        name: document.name,
        process: process
      })
      if (response.process) {
        document.process = response.process
      }
      if (document.process === 4) {
        remove(this.records[response.skladi_id], (record) => { return record.doc_id === response.doc_id })
      }
      this._messageBar = false
      this._messageType = response.success ? 'success' : 'failure'
      this._messageText = response.message
      this._messageBar = true
      document.loading = false
      this.$forceUpdate()
    },
    showShipConfirmationModal (document) {
      this.$refs.shipConfirmationModal.open(document)
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss">
  .documents {
    .v-expansion-panel-content__wrap {
      padding: 0;
    }
  }
</style>
